export const CARD_ASPECT = 1.397;
export const CARD_REL_HEIGHT = 0.14;

export const CARD_LOGIN_SCALE = 1.5;
export const CARD_LOGIN_RPOS = 1.1;
export const LOGIN_ANCHOR = 0.6;
export const LOGIN_WIDTH = 300;
export const LOGIN_PAD = 40;

export const FULL_STACK_HEIGHT = 40.0;
export const FULL_STACK = 52;
export const STACK_X = 200;
export const STACK_Y = 400;

export const ROWS = 5;
export const PYRAMID_CARDS = (ROWS * (ROWS + 1)) / 2;
export const PYRAMID_X_ANCHOR = 0.5;
export const PYRAMID_Y_ANCHOR = 0.5;
export const CARD_PYRAMID_Y_PAD = 1.1;
export const CARD_PYRAMID_X_PAD = 1.15;

export const CARD_SHAPE_Y_PAD = 1.1;
export const CARD_SHAPE_X_PAD = 1.15;

export const TRANSITION_TIME_DRAW = 0.05;
export const TRANSITION_TIME_FLIP = 0.02;
export const TRANSITION_TIME_FLIP_UP = 0.04;
export const TRANSITION_TIME_STACK = 0.01;
export const TRANSITION_RANDOMNESS = 0.02;

export const USER_ME_CARD_SCALE = 1.4;
export const USER_CARD_SCALE = 0.75;
export const USER_CARD_WIDTH = 3;
export const UI_PAD = 15;

export const CARD_VIEW_SCALE = 1.2;
export const CARD_VIEW_X = 0.5;
export const CARD_VIEW_Y = 0.5;

export const BACKGROUND_OPACITY = 0.1;

export const ELEVATION_SCALE_COEFF = 0.01;

export const MAX_PLAYERS = 12;
export const HOVER_ELEVATION = 10;
export const BUS_CARD_SCALE = 1.4;
